import React from "react";
import { Button, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTypedDispatch } from "hooks/store";
import {
    CurrentDrawerOpenType,
    updateCurrentDrawerOpenType,
    updateDrawerTitle,
} from "state/slices/RightDrawerSlice";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";

interface ComponentProps {
    type: CurrentDrawerOpenType;
    classes: string;
    isIcon: boolean;
}
const defaultProps = {
    type: CurrentDrawerOpenType.AddObject,
    classes: "",
    isIcon: false,
};
const DrawerGoBackComponent = ({ classes, isIcon }: ComponentProps): JSX.Element => {
    const dispatch = useTypedDispatch();
    const handleGoBack = (): void => {
        dispatch(updateDrawerTitle("Select a New Item to place into the OR"));
        dispatch(updateCurrentDrawerOpenType(CurrentDrawerOpenType.AddObject));
    };
    if (isIcon) {
        return (
            <IconButton size="medium" onClick={handleGoBack}>
                <ArrowBackOutlinedIcon style={{ color: "#6BC2B8", fontSize: "30px" }} />
            </IconButton>
        );
    }
    return (
        <div className={`drawerGoBack ${classes}`}>
            <Button
                className="btnGoBack"
                onClick={handleGoBack}
                startIcon={<ArrowBackIcon className="iconArrow" />}
            >
                Back
            </Button>
        </div>
    );
};

DrawerGoBackComponent.defaultProps = defaultProps;

export default DrawerGoBackComponent;
